import React, {useEffect} from "react";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

//helpers:
import {toAbsoluteUrl} from "../../../_metronic/_helpers";

//styles:
import "../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";

//redux:
import {loadParameter} from "../../redux_slices/contextSlice";

//components:

const LoginWrapper = ({children}) => {
    const {t} = useTranslation();

    const currentYear = new Date().getFullYear();
    const customBackground = useSelector(state => loadParameter(state, "loginBackground"));
    const customLogo = useSelector(state => loadParameter(state, "loginLogo"));

    const loginExtraLink = useSelector(state => loadParameter(state, "loginExtraLink"));
    const loginExtraLinkText = useSelector(state => loadParameter(state, "loginExtraLinkText"));

    useEffect(() => {
        document.title = `Winnow | Authentication`;
    }, []);

    return (
        <div className="loginpage">
            {/*begin::Login*/}
            <div
                className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
                id="kt_login"
            >
                {/*begin::Aside*/}
                <div
                    className="login-aside"
                    style={{
                        backgroundImage: `url(${customBackground || "/media/bg/bg-13.PNG"})`,
                    }}
                >
                    <div className="login_aside_dark-overlay"/>
                    {/*begin: Aside Container*/}
                    <div className="login_aside_content">
                        <Link to="/" className="flex-column-auto">
                            <img
                                alt="logo"
                                className="logo"
                                src={customLogo || toAbsoluteUrl("/media/logos/winnow-white.png")}
                            />
                        </Link>

                        {/* start:: Aside footer for desktop */}
                        <div className="d-none flex-column-auto d-lg-flex justify-content-between mt-10">
                            <div className="opacity-70 font-weight-bold text-white">
                                &copy; {currentYear} Winnow - {process.env.REACT_APP_VERSION}/
                                {process.env.REACT_APP_BUILD}
                            </div>
                            {loginExtraLink && loginExtraLinkText ? (
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={`${loginExtraLink}`}
                                    className="opacity-70 text-white text-hover-muted ml-10"
                                >
                                    {loginExtraLinkText}
                                </a>
                            ) : null}
                        </div>
                        {/* end:: Aside footer for desktop */}
                    </div>
                    {/*end: Aside Container*/}
                </div>
                {/*begin::Aside*/}

                {/*begin::Content*/}
                <div className="flex-row-fluid d-flex flex-column position-relative p-10 overflow-hidden">
                    <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
                        {children}
                    </div>
                    <div className="d-none flex-column-auto d-lg-flex ml-lg-auto justify-content-between mt-10">
                        <div className="d-flex">
                            <a
                                href="https://omnios.ai/winnow/terms"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-dark text-hover-muted"
                            >
                                {t("AUTH.GENERAL.PRIVACY")}
                            </a>
                            <a
                                href="https://omnios.ai/winnow/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-dark text-hover-muted ml-10"
                            >
                                {t("AUTH.GENERAL.CONTACT")}
                            </a>
                        </div>
                    </div>

                    {/* begin::Mobile footer */}
                    <div
                        className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
                        <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                            &copy; {currentYear} Winnow - {process.env.REACT_APP_VERSION}/{process.env.REACT_APP_BUILD}
                        </div>
                        <div className="d-flex order-1 order-sm-2 my-2">
                            {loginExtraLink && loginExtraLinkText ? (
                                <a
                                    href={`${loginExtraLink}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-dark text-hover-muted mr-10"
                                >
                                    {loginExtraLinkText}
                                </a>
                            ) : null}
                            <a
                                href="https://omnios.ai/terms-and-conditions/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-dark text-hover-muted"
                            >
                                {t("AUTH.GENERAL.PRIVACY")}
                            </a>
                            <a
                                href="https://omnios.ai/winnow/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-dark text-hover-muted ml-10"
                            >
                                {t("AUTH.GENERAL.CONTACT")}
                            </a>
                        </div>
                    </div>
                    {/* end::Mobile footer */}
                </div>
                {/*end::Content*/}
            </div>
            {/*end::Login*/}
        </div>
    );
};
export default LoginWrapper;
